import { memo } from "react";
import { useTranslation } from "react-i18next";
import {
    IconExport,
    SharedButtonDefault,
    StyledCard,
    Users,
    ComponentContactSortIcon,
    IconArrowUp,
    StyledInfoTable,
    IconCopy,
} from "@components";
import { IActivity, IProfileEnrolls } from "@interfaces";
import { Switch, Row, Col, Tooltip } from "antd";
import styled from "styled-components";
import { enumSortBy, enumContactSortFields, dateFormatHM } from "@configs";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectContact, setLoading, selectAuth } from "@redux";
import moment from "moment";
import { activityApi } from "@api";
import { useNotify } from "@utils";
interface IProps {
    activity: IActivity | undefined;
    callbackFun: () => void;
}

export const ComponentInfo = memo((props: IProps) => {
    const { t } = useTranslation();
    const search_params = useSelector(selectContact).paramsContact;
    const [params, setParams] = useState(search_params);
    const [selectedActivity, setSelectedActivity] = useState<IProfileEnrolls>();
    const dispatch = useDispatch();
    const { success, error } = useNotify();
    const organization_id = useSelector(selectAuth).auth?.organization_data?._id;
    const { activity, callbackFun } = props;
    const handleSort = (sortField: enumContactSortFields, sortBy: enumSortBy) => {
        const newSortParams = { ...params, sortField, sortBy };
        setParams(newSortParams);
    };
    const handleCopyText = () => {
        console.log("copy");
    };
    const handleUpdateFull = async (e: boolean) => {
        try {
            dispatch(setLoading(true));
            const { data } = await activityApi.setEnableFullActivity({
                organization_id: organization_id || "",
                activity_id: activity?._id || "",
                is_enable: activity?.is_enable || false,
                is_full: e,
            });
            if (data.error === "0") {
                callbackFun();
                success(data.msg);
                dispatch(setLoading(false));
            } else {
                error(data.msg);
                dispatch(setLoading(false));
            }
        } catch (err: any) {
            dispatch(setLoading(false));
            if (err) {
                error(err.msg);
            }
        }
    };
    return (
        <StyledInfoTable>
            <div className="page-body">
                <div className="left-side">
                    <div className="card-wrap">
                        <StyledInfo>
                            <div className="info-row">
                                <div>
                                    <h5>
                                        <Users color="#130F26" />{" "}
                                        {t("page.total_number_participants")}
                                    </h5>
                                </div>
                                <div>
                                    <p className="count">
                                        <span className="number eng">
                                            {activity?.profile_enrolls.length}
                                        </span>
                                        {activity?.enroll_qty !== -1 && (
                                            <span className="base eng">{`/ ${activity?.enroll_qty} คน`}</span>
                                        )}
                                    </p>
                                </div>
                            </div>
                            <div className="toggle-row">
                                <p>
                                    <span className="label">{t("page.closed_for_attendees")}</span>
                                    {/* <span className="small">{t("page.make_up")}</span> */}
                                    <Switch
                                        onChange={handleUpdateFull}
                                        checked={activity?.is_full}
                                    ></Switch>
                                </p>
                            </div>
                        </StyledInfo>
                    </div>
                    <div className="card-wrap">
                        <StyledCard>
                            <header>
                                <h5>{t("page.total_number_participants")}</h5>
                                <SharedButtonDefault
                                    style={{
                                        color: "white",
                                        background: "#0D6EFD",
                                        fontWeight: 600,
                                        border: 0,
                                        padding: "20px 32px",
                                        height: "49px",
                                    }}
                                    customIcon={<IconExport />}
                                    text={t("page.export")}
                                    type="default"
                                    size="default"
                                    className="default-btn"
                                />
                            </header>
                            <div className="table-header">
                                <Row
                                    gutter={10}
                                    type="flex"
                                    justify="space-between"
                                    align="middle"
                                    className="header-row"
                                >
                                    <Col className="col-item" span={4}>
                                        <p>{t("page.no")}</p>
                                        <div className="filter-button">
                                            <ComponentContactSortIcon
                                                handleSort={handleSort}
                                                sortBy={enumSortBy.ASC}
                                                sortField={enumContactSortFields.FULL_NAME}
                                                searchParams={params}
                                            />
                                            <ComponentContactSortIcon
                                                handleSort={handleSort}
                                                sortBy={enumSortBy.DESC}
                                                sortField={enumContactSortFields.FULL_NAME}
                                                searchParams={params}
                                            />
                                        </div>
                                    </Col>
                                    <Col className="col-item" span={10}>
                                        <p>{t("page.list_of_participants")}</p>
                                        <div className="filter-button">
                                            <ComponentContactSortIcon
                                                handleSort={handleSort}
                                                sortBy={enumSortBy.ASC}
                                                sortField={enumContactSortFields.FULL_NAME}
                                                searchParams={params}
                                            />
                                            <ComponentContactSortIcon
                                                handleSort={handleSort}
                                                sortBy={enumSortBy.DESC}
                                                sortField={enumContactSortFields.FULL_NAME}
                                                searchParams={params}
                                            />
                                        </div>
                                    </Col>
                                    <Col className="col-item" span={10}>
                                        <p>{t("page.date_time_of_participation")}</p>
                                        <div className="filter-button">
                                            <ComponentContactSortIcon
                                                handleSort={handleSort}
                                                sortBy={enumSortBy.ASC}
                                                sortField={enumContactSortFields.FULL_NAME}
                                                searchParams={params}
                                            />
                                            <ComponentContactSortIcon
                                                handleSort={handleSort}
                                                sortBy={enumSortBy.DESC}
                                                sortField={enumContactSortFields.FULL_NAME}
                                                searchParams={params}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div className="table-body">
                                {activity?.profile_enrolls.map((item, index) => (
                                    <Row key={index} onClick={() => setSelectedActivity(item)}>
                                        <Col className="col-item" span={3}>
                                            <p className="eng">{index}</p>
                                        </Col>
                                        <Col className="col-item row-title" span={7}>
                                            <p>{item.name}</p>
                                        </Col>
                                        <Col className="col-item" span={7}>
                                            <p className="eng">
                                                {moment(item.created_date).format(dateFormatHM)}
                                            </p>
                                        </Col>
                                        <Col className="col-item icon" span={7}>
                                            <IconArrowUp />
                                        </Col>
                                    </Row>
                                ))}
                            </div>
                        </StyledCard>
                    </div>
                </div>
                <div className="right-side">
                    {selectedActivity && (
                        <div className="detail-info">
                            <div className="detail-title">{t("page.participant_information")}</div>
                            <div className="info-layout">
                                <div className="left">
                                    <div className="item">
                                        <div className="label">{t("page.surname")}</div>
                                        <div className="value">
                                            {selectedActivity.name || "-"}
                                            <Tooltip
                                                title={
                                                    t("message.copy")
                                                    // isCopy.status && isCopy.value === 2
                                                    //     ? t("message.copied")
                                                    //     : t("message.copy")
                                                }
                                            >
                                                <div className="copy" onClick={handleCopyText}>
                                                    <IconCopy />
                                                </div>
                                            </Tooltip>
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="label">{t("page.gender")}</div>
                                        <div className="value">
                                            {selectedActivity.gender || "-"}
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="label">{t("page.telephone")}</div>
                                        <div className="value">{selectedActivity.tel}</div>
                                    </div>
                                </div>
                                <div className="right">
                                    <div className="item">
                                        <div className="label">{t("page.id_card_number")}</div>
                                        <div className="value">{selectedActivity.card_no}</div>
                                    </div>
                                    <div className="item">
                                        <div className="label">{t("page.age")}</div>
                                        <div className="value">{selectedActivity.age}</div>
                                    </div>
                                    <div className="item">
                                        <div className="label">{t("page.email")}</div>
                                        <div className="value">{selectedActivity.email}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="item">
                                <div className="label">{t("page.address")}</div>
                                <div className="value">{selectedActivity.address}</div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </StyledInfoTable>
    );
});
const StyledInfo = styled.div`
    padding: 20px 32px;
    border-radius: 4px;
    background-color: white;
    max-width: 760px;
    /* flex-direction: column; */
    .info-row {
        display: flex;
        justify-content: space-between;
    }
    .toggle-row {
        display: flex;
        justify-content: flex-end;
    }
    h5 {
        font-style: normal;
        font-weight: 400;
        font-size: 22px;
        line-height: 33px;
        color: #29304d;
    }
    .count {
        display: flex;
        justify-content: end;
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        column-gap: 10px;
        .number {
            font-style: normal;
            font-weight: 600;
            font-size: 35px;
            line-height: 53px;
            color: #29304d;
        }
        .base {
            font-style: normal;
            font-weight: 600;
            font-size: 20px;
            line-height: 30px;
            color: #29304d;
        }
    }
    .label {
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        color: #29304d;
        padding: 0 6px;
    }
    .small {
        font-style: normal;
        font-weight: 300;
        font-size: 16px;
        line-height: 24px;
        color: #8a959e;
        padding: 0 6px;
    }
`;
